import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Package, Percent, Check } from 'lucide-react';
import { toast } from 'sonner';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/i18n/LanguageContext';

export const BundleOfferCard = ({ bundle }) => {
  const { addBundleToCart, isBundleInCart } = useCart();
  const { t } = useLanguage();
  const inCart = isBundleInCart(bundle);
  const bundleKey = bundle.student_id ? `${bundle.bundle_id}_${bundle.student_id}` : bundle.bundle_id;

  return (
    <Card className="bg-card border-2 border-green-500/30 overflow-hidden" data-testid={`bundle-offer-${bundleKey}`}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <Package className="w-5 h-5 text-green-500" />
              <h3 className="font-bold text-lg">
                {bundle.student_name ? `${bundle.name} — ${bundle.student_name}` : bundle.name}
              </h3>
            </div>
            <p className="text-sm text-muted-foreground">
              {bundle.photo_count} {t('bundles.photosIncluded')}
              {bundle.class_name ? ` · ${bundle.class_name}` : ''}
            </p>
          </div>
          {!bundle.fixed_price && bundle.discount_percent > 0 && (
            <div className="flex items-center gap-1 bg-green-500/10 px-3 py-1 rounded-full">
              <Percent className="w-3 h-3 text-green-500" />
              <span className="font-mono text-sm font-bold text-green-500">
                {bundle.discount_percent}% {t('bundles.discount')}
              </span>
            </div>
          )}
        </div>
        <div className="space-y-2 mb-4">
          {bundle.savings > 0 && (
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">{t('bundles.originalPrice')}</span>
              <span className="font-mono line-through text-muted-foreground">CHF {bundle.original_price.toFixed(2)}</span>
            </div>
          )}
          {bundle.savings > 0 && (
            <div className="flex justify-between text-sm">
              <span className="text-green-500">{t('bundles.youSave')}</span>
              <span className="font-mono text-green-500">-CHF {bundle.savings.toFixed(2)}</span>
            </div>
          )}
          <div className={`flex justify-between ${bundle.savings > 0 ? 'border-t border-border pt-2' : ''}`}>
            <span className="font-bold">{t('bundles.bundlePrice')}</span>
            <span className="font-mono text-xl font-bold text-primary">CHF {bundle.discounted_price.toFixed(2)}</span>
          </div>
        </div>
        <Button
          onClick={() => { addBundleToCart(bundle); toast.success(t('bundles.addBundleToCart')); }}
          disabled={inCart}
          className={inCart ? 'w-full' : 'w-full bg-green-600 hover:bg-green-700'}
          data-testid={`buy-bundle-${bundleKey}`}
        >
          {inCart ? (
            <>
              <Check className="w-4 h-4 mr-2" />
              {t('bundles.bundleInCart')}
            </>
          ) : (
            <>
              <Package className="w-4 h-4 mr-2" />
              {t('bundles.addBundleToCart')}
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};
